<template>
  <div
    v-if="category.items.length > 0"
    :class="{
      'bto-sb-tournament-us': isUS,
      'bto-sb-widget bto-sb-widget-prematch bto-sb-widget-prematch-grid bto-sb-category-tournaments':
        !isUS,
    }">
    <div
      class="bto-sb-widget-title"
      :class="{
        'bto-sb-title-icon': isUS,
        'bto-sb-widget-nav-icon bto-sb-widget-title-flag': !isUS,
      }">
      <span class="bto-sb-flag bto-sb-flag-oval" :class="category.class"></span>
      <h3>{{ category.name }} ({{ category.numberOfItems }})</h3>
      <ul class="bto-sb-widget-nav-icon">
        <li>
          <router-link :to="getCategrotyRouteLink(category)" class="bto-sb-widget-nav-icon-more">
            <span>{{ t("Mobile.More") }}</span>
          </router-link>
        </li>
        <li v-if="SHOW_FAVORITES">
          <ToggleFavoriteComponent :favType="2" :sport="sport" :category="category" />
        </li>
        <li @click="toggleCollapse()">
          <a
            :class="
              tabCollapsed ? 'bto-sb-widget-nav-icon-expand' : 'bto-sb-widget-nav-icon-collapse'
            ">
          </a>
        </li>
      </ul>
    </div>
    <div
      class="bto-sb-widget-content"
      v-show="!tabCollapsed"
      :class="{ 'bto-sb-widget-content-grid': !isUS }">
      <div
        :class="{ 'bto-sb-tournament-items': isUS, 'bto-sb-widget-content-grid-item': !isUS }"
        v-for="(tournaments, index) in chunkArrayExact(category.items, isUS ? 1 : 2)"
        :key="index">
        <router-link
          v-for="(tournament, tIdx) in tournaments"
          :key="tIdx"
          :to="getTournamentLink(tournament)">
          <span class="bto-sb-tournament-name">{{ tournament.name }}</span>
          <span class="bto-sb-tournament-no">({{ tournament.numberOfItems }})</span>
          <ToggleFavoriteComponent
            v-if="SHOW_FAVORITES"
            :favType="3"
            :sport="sport"
            :tournament="tournament" />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import { chunkArrayExact } from '../../../services/utils';
  import { LAYOUT_NAME } from '../../../models/enums/layout-const';
  import { urlFriendlyParam } from '@bto-services/utils';
  import ToggleFavoriteComponent from '../../common/toggle-favorite-component';


  export default {
    name: "TournametsList",
    components: {
      ToggleFavoriteComponent
    },
    data() {
      return {
        tabCollapsed: false,
        isUS: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
        SHOW_FAVORITES: APP_SETTINGS.category.showFavorites,
      };
    },
    props: {
      category: {
        type: Object,
        default: () => { },
      },
      sport: {
        type: Object,
        default: () => { },
      },
    },
    methods: {
      toggleCollapse() {
        this.tabCollapsed = !this.tabCollapsed;
      },
      getTournamentLink(tournament) {
        let routeParams = {};
        const name = tournament.cType === 4 ? 'seoTournamentGroup' : 'seoTournament';
        routeParams.fixtureIds = `${tournament.id || '-'}`;
        routeParams.tournament = urlFriendlyParam(tournament.name);
        routeParams.sport = urlFriendlyParam(this.sport.name || '');
        return { name, params: routeParams };
      },
      getCategrotyRouteLink(category) {
        let params = {};
        const name = category.cType === 2 ? 'seoCategoryGroup' : 'seoCategory';
        params.categoryId = category.id;
        params.category = urlFriendlyParam(category.name);
        params.sport = urlFriendlyParam(this.sport.name || '');
        return { name, params };
      },
      chunkArrayExact,
    },
  };
</script>
